import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from "react";
/**
 * Renders grid fragment. It is a placeholder, since the props are used by the grid layout.
 *  We cannot use Fragment directly, because this would inject layout props
 * @param props
 * @returns
 */
export function GridFragment(props) {
    return _jsx(Fragment, { children: props.children });
}
//# sourceMappingURL=GridFragment.js.map